import * as stateNames from 'constants/states'
import * as actionTypes from 'constants/actionTypes'
import createThunkReducer from 'utils/createThunkReducer'

export default {
  [stateNames.PERSON_CREATE]: createThunkReducer(actionTypes.PERSON_CREATE),
  [stateNames.PERSON_LIST]: createThunkReducer(actionTypes.PERSON_LIST),
  [stateNames.PERSON_DELETE]: createThunkReducer(actionTypes.PERSON_DELETE),
}
